/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ListComponent} from '../../../../admin-shared/crud-components/list/list.component';
import {CrudConfig} from '../../../../admin-shared/interfaces/crud.config';
import {DAM_RELATED_COLLECTION_FORM} from '../dam-related-collection-forms.config';


@Component({
  selector: 'app-dam-related-collection-list',
  templateUrl: '../../../../admin-shared/crud-components/list/list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamRelatedCollectionListComponent extends ListComponent<any> implements OnInit {

  config: CrudConfig = {
    uri: '/dam/dam-related-collection',
    columns: DAM_RELATED_COLLECTION_FORM,
    defaultSortColumn: 'header',
    defaultSortDirection: 'asc',
    title: 'Коллекции'
  };

  ngOnInit() {
    super.setConfig(this.config);
    super.ngOnInit();
  }
}
